import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { url } from '../utils/config';
import fetchData from "../custom_functions/fetchData";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import postData from "../custom_functions/postData";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";
import patchData from "../custom_functions/patchData";
import { setLoader } from "../reusable_components/Loader";

function Register(props) {
    const [formData, setFormData] = useState({});
    const [locations, setLocations] = useState([])
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    let requiredFields = ['email', 'confirmEmail', 'userName', 'phone', 'firstName', 'lastName'];

    if (props.formType === 'technician') {
        let fields = ['startTime', 'endTime', 'weekOff1', 'weekOff2']
        requiredFields = requiredFields.concat(fields);
    } else {
        requiredFields.push('location')
    }

    useEffect(() => {
        if (props.data) {
            const data = { ...props.data };
            data.confirmEmail = props.data.email
            setFormData(data);
        }
        if (props.formType === 'manager') {
            fetchData(`${url}/all_locations`, console.log, (d) => {
                d.hubs.forEach(h => h.id = 'hub-' + h.id);
                d.spokes.forEach(s => s.id = 'spoke-' + s.id);
                setLocations(d.hubs.concat(d.spokes))
            })
        }
    }, [props.data]);

    function updateFormData(e) {
        const { name, value } = e.target;
        const data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    async function register() {
        // Regular expressions for validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/; // Ensures exactly 10 digits (numeric only)

        // Required fields based on form type
        const requiredFields = [
            "email", "confirmEmail", "userName", "firstName", "lastName", "phone"
        ];
        if (props.formType === "technician") {
            requiredFields.push("startTime", "endTime", "weekOff1", "weekOff2");
        } else {
            requiredFields.push("location");
        }

        // Check for missing fields
        let miss = requiredFields.filter(field => !formData[field] || formData[field].trim() === "");

        // Additional validations
        if (!emailRegex.test(formData.email)) miss.push("email");
        if (formData.confirmEmail !== formData.email) {
            miss.push("confirmEmail");
            toast.error("Email and Confirm Email do not match. Please enter the same email in both fields.", { autoClose: 3000 });
        }

        // Phone validation: Check if it's exactly 10 digits and numeric
        if (!phoneRegex.test(formData.phone)) {
            miss.push("phone");
            toast.error("Phone number must be exactly 10 digits and contain only numbers.", { autoClose: 3000 });
        }

        if (props.formType === "technician" && formData.weekOff1 === formData.weekOff2) miss.push("weekOff1/weekOff2");

        if (miss.length === 0 && !inputErrors.includes("error")) {
            postData(`${url}/${props.formType}_signup`, formData,
                (error) => {
                    console.log(error);
                    toast.error(error.response.data.message, { autoClose: 3000 });
                },
                (data) => {
                    toast.success(data.message, { autoClose: 3000 });
                    props.setShowForm(false);
                    props.reload(1 + Math.random());
                }
            );
        } else {
            setMissingFields(miss);
            setShowInputError(true);
        }
    }

    async function modify() {
        if (
            formData.email && formData.email.match('@') && formData.email.match('.') &&
            formData.confirmEmail && formData.confirmEmail === formData.email &&
            formData.userName && formData.userName.length > 0 &&
            formData.firstName && formData.firstName.length > 0 &&
            formData.lastName && formData.lastName.length > 0 &&
            (
                props.formType === 'technician' ?
                    formData.startTime &&
                    formData.endTime &&
                    formData.weekOff1 &&
                    formData.weekOff2 && formData.weekOff1 !== formData.weekOff2
                    :
                    formData.location
            ) &&
            !inputErrors.includes('error')
        ) {
            patchData(`${url}/${props.formType}/${formData.id}`, formData, 
                (error) => {
                    toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
                },
                (data) => {
                    toast.success(data.message, { autoClose: 3000 });
                    
                    // Pass updated technician data back to parent component
                    if (props.onUpdateSuccess && props.formType === 'technician') {
                        props.onUpdateSuccess({...formData});
                    }
                    
                    props.setShowForm(false);
                    props.reload(1 + Math.random());
                }
            );
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    return (
        <div className={modalContainer}>
            <div className="px-4 flex justify-center flex-col fixed w-2/3">
                <div className="rounded-lg bg-white w-full p-8 overflow-y-auto h-3/4">

                    <div className={modalTitle}>{props.action === 'edit' ? `Edit ${props.formType === 'technician' ? 'Technician' : 'Manager'}` : `Add ${props.formType === 'technician' ? 'Technician' : 'Manager'}`}</div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Email</label>
                        <div className="col-span-2">
                            <Input
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="email"
                                value={formData.email}
                                type="email"
                                className={inputStyle}
                                placeHolder="Enter Email"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Confirm Email</label>
                        <div className="col-span-2">
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="confirmEmail"
                                value={formData.confirmEmail}
                                type="email"
                                className={inputStyle}
                                placeHolder="Confirm Email"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Username</label>
                        <div className="col-span-2">
                            <Input
                                index={2}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="userName"
                                value={formData.userName}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter Username"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Phone</label>
                        <div className="col-span-2">
                            <Input
                                index={3}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="phone"
                                value={formData.phone}
                                type="tel"
                                className={inputStyle}
                                placeHolder="Enter Phone"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>First Name</label>
                        <div className="col-span-2">
                            <Input
                                index={4}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="firstName"
                                value={formData.firstName}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter First Name"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Last Name</label>
                        <div className="col-span-2">
                            <Input
                                index={5}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="lastName"
                                value={formData.lastName}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter Last Name"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>


                    {
                        props.formType === 'technician' ?
                            <div>
                                <div className="py-1">
                                    <div className="flex">
                                        <div className="w-full flex justify-around mr-2">
                                            <label className={label}>Shift Start Time</label>
                                            <div>
                                                <Input
                                                    index={5}
                                                    inputErrors={inputErrors}
                                                    setInputErrors={setInputErrors}
                                                    missingFields={missingFields}
                                                    required={true}
                                                    type="time"
                                                    name="startTime"
                                                    value={formData.startTime}
                                                    className={inputStyle}
                                                    onChange={e => updateFormData(e)}
                                                />
                                            </div>
                                        </div>
                                        

                                        
                                        <div className="w-full flex justify-around ml-2">
                                            <label className={label}>Shift End Time</label>
                                            <div className={label}>
                                                <Input
                                                    index={6}
                                                    inputErrors={inputErrors}
                                                    setInputErrors={setInputErrors}
                                                    missingFields={missingFields}
                                                    required={true}
                                                    type="time"
                                                    name="endTime"
                                                    value={formData.endTime}
                                                    className={inputStyle}
                                                    onChange={e => updateFormData(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              
                                <div className="py-1 px-2">
                                    <div className="flex">
                                        <div className="w-full flex justify-around mr-2">
                                            <label className={label}>Week-Off Day 1</label>
                                            <div>
                                                <Select
                                                    index={7}
                                                    inputErrors={inputErrors}
                                                    setInputErrors={setInputErrors}
                                                    missingFields={missingFields}
                                                    required={true}
                                                    name='weekOff1'
                                                    value={formData.weekOff1}
                                                    options={days}
                                                    className={inputStyle}
                                                    onChange={e => updateFormData(e)}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full flex justify-around ml-2">
                                            <label className={label}>Week-Off Day 2</label>
                                            <div>
                                                <Select
                                                    index={8}
                                                    inputErrors={inputErrors}
                                                    setInputErrors={setInputErrors}
                                                    missingFields={missingFields}
                                                    required={true}
                                                    name='weekOff2'
                                                    value={formData.weekOff2}
                                                    options={days}
                                                    className={inputStyle}
                                                    onChange={e => updateFormData(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="w-full ml-2">
                                        <label className={label}>Hourly Rate</label>
                                        <div>
                                        <Input
                                                    index={9}
                                                    inputErrors={inputErrors}
                                                    setInputErrors={setInputErrors}
                                                    missingFields={missingFields}
                                                    required={true}
                                                    type="number"
                                                    name="hourlyCost"  
                                                    value={formData.hourlyCost}
                                                    className={inputStyle}
                                                    onChange={e => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,3}$/.test(value)) {
                                                            updateFormData(e);
                                                        }
                                                    }}/>
                                        </div>
                                    </div>
                                </div>    
                            </div> :
                            <div className="grid grid-cols-6 py-1 px-2">
                                <label className={label}>Location</label>
                                <div className="col-span-2">
                                    <Select
                                        name="location"
                                        className={inputStyle}
                                        value={formData.location}
                                        placeHolder='Location'
                                        valueKey={'id'}
                                        nameKey={'name'}
                                        options={locations}
                                        onChange={e => updateFormData(e)}
                                    />
                                </div>

                            </div>
                    }
                    <div className="flex justify-between py-3 px-16 gap-8">
                        <button onClick={e => {
                            props.setShowForm(false);
                            setFormData({});
                            setInputErrors([]);
                            setMissingFields([]);
                            setShowInputError(false);
                        }} className={btnCancel}>Cancel</button>
                        <button onClick={e => { props.data ? modify() : register() }} className={btnOne}>Submit</button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Register;